module.exports = __webpack_public_path__ + "key-benefits-text.svg?ac838f8e62581bba6505649fac73c97b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/key-benefits-text.svg
// module id = 122
// module chunks = 0